import { Injectable } from '@angular/core';
import {Resolve, Router} from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';

import {NgxSpinnerService} from 'ngx-spinner';
import {AuthService} from '../../core/services';

@Injectable()
export class RestPasswordResolver implements Resolve<any> {
  constructor(private authService: AuthService,
              private router: Router,
              private spinner: NgxSpinnerService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    console.log(route.params.token);
    return this.authService.checkResetPassword(route.params.token)
      .pipe(map(data => {
        if (!data.success) {
          this.router.navigateByUrl('/auth/login');
        }
      }));
  }
}
